<div class="wrapper">
  <div class="column">
    <div class="badge-container">
      <rt-ai-logo size="medium" />
    </div>
    <div class="text-content">
      <div class="subheading" layout>
        {{
          'app.evaluation_insights.banner.key_takeaways'
            | translate: { evaluationsCount: evaluationsCount() }
        }}
        <rt-admins-avatars
          margin-left-small-x
          [admins]="users()"
          [stacked]="true"
          [avatarSize]="'top-nav-company-selector'"
        />
      </div>
      <rt-heading variant="heading large">
        {{ 'app.evaluation_insights.banner.heading' | translate }}
      </rt-heading>
    </div>
  </div>
  <div class="column">
    <rt-button variant="tertiary" (click)="navigateToInsights.emit()" margin-right>
      {{ 'app.evaluation_insights.banner.view_insights' | translate }}
    </rt-button>
    <rt-icon-button iconName="close" size="small" variant="plain" (click)="close.emit()" />
  </div>
</div>
